<script>
import ModalItem from "@/layouts/modal/ModalItem.vue";

export default {
  name: "ModalLayout",
  components: {ModalItem},
  props: {
    id: [String, Number],
    /**
     * isShow
     * 팝업 표시 여부
     */
    isShow: Boolean,
    items: Array,
  },
  methods: {
  }
}
</script>

<template>
  <div class="items-center justify-center grid"
       :class="{'hidden': !isShow, 'open': isShow}"
       style="background: #33333399; position:fixed; top:0; left:0; width:100%; height:100%; z-index: 51000;  " >
    <modal-item v-for="item in items" :id="item.id" :key="item.id" :name="item.title" :is-show="true" :skip-date="item.skipDate">
      <div>
        <div class="main-popup-body" v-html="item.html"/>
      </div>
    </modal-item>
  </div>
</template>

<style lang="scss" scoped>

</style>
